import * as React from 'react'
import { DeleteOutlined, EditOutlined, PlusOutlined, DownOutlined, LinkOutlined, LockOutlined, UnlockOutlined, AppstoreAddOutlined } from '@ant-design/icons'
import { Button, Col, Divider, Modal, PageHeader, Row, Tree } from 'antd'
import { Dropdown, Menu, Space, Typography, Tooltip, Spin } from 'antd'

import { DataNode } from 'antd/lib/tree'

import { IConfigurazioneService } from '../../services/ConfigurazioneService'
import container from '../../wires/Bootstrapper'
import SERVICE_IDENTIFIER from '../../wires/Identifiers'

import { CatDataNode, CategorieModel } from '../../models/ConfigurazioneModels'
import { ModalCategoria, OperationType } from './ModalCategoria'
import { EsempioCategorie } from './EsempioCategorie'
import Operation from 'antd/lib/transfer/operation'
import Search from 'antd/lib/input/Search'
const { Text } = Typography

class PageCategorieState extends CategorieModel {
    ModalVisible: boolean = false
    SelectedNode: DataNode
    OperationModal: OperationType
}

export class PageCategorie extends React.Component<any, PageCategorieState> {

    service: IConfigurazioneService

    constructor(props) {
        super(props)
        this.state = new PageCategorieState()
        this.service = container.get(SERVICE_IDENTIFIER.CONFIGURAZIONE_SERVICE)
    }

    componentDidMount() {
        this.loadPage()
    }

    loadPage = async () => {
        let resp = await this.service.GetCategorie()
        if (resp.IsValid == true)
            this.setState(resp)
    }

    onAddClick = (node: DataNode) => {
        debugger
        this.showModal((node as CatDataNode).Level > 0 ? OperationType.ADD : OperationType.ADDFIRST, node);
        this.toggleModal(true)
    }

    onEditClick = (node: DataNode) => {
        this.showModal(OperationType.EDIT, node);
        this.toggleModal(true)
    }

    onDeleteClick = (node: DataNode) => {
        this.showModal(OperationType.DELETE, node);
        Modal.confirm({
            title: "Elimina",
            content: "Eliminare la categoria?",
            onOk: async () => {
                let id = this.state.SelectedNode.key as string
                let resp = await this.service.EliminaCategoria(id)
                if (resp.IsValid === true) {
                    this.setState({ SelectedNode: null })
                    this.loadPage()
                }
            }
        })
    }

    showModal = (operation: OperationType, data: DataNode) => {
        this.setState({ SelectedNode: data, OperationModal: operation })
    }

    toggleModal = (visible: boolean) => {
        this.setState({ ModalVisible: visible })
    }

    //renderExtra = () => {
    //    if (this.state.SelectedNode != null)
    //        return [
    //            <Button type="primary" key="edit" icon={<EditOutlined />} onClick={() => this.onEditClick()}>Modifica</Button>,
    //            <Button type="primary" key="delete" icon={<DeleteOutlined />} onClick={() => this.onDeleteClick()}>Elimina</Button>
    //        ]
    //    else
    //        return [
    //            <Button type="primary" key="add" icon={<PlusOutlined />} onClick={() => this.onAddClick()}>Aggiungi</Button>
    //        ]
    //}

    renderTreeMenu = (node: CatDataNode) => {
        return <Menu>

            {node.Level < 3 ? <Menu.Item key="aggiungi" icon={<AppstoreAddOutlined />} onClick={() => this.onAddClick(node)} >Aggiungi</Menu.Item> : <></>}
            <Menu.Item key="modifica" icon={<EditOutlined />} onClick={() => this.onEditClick(node)} >Modifica</Menu.Item>
            <Menu.Item key="elimina" icon={<DeleteOutlined />} onClick={() => this.onDeleteClick(node)}>Elimina</Menu.Item>
        </Menu>
    }

    renderTreeTitle = (node: CatDataNode) => {
        // Se non è una foglia non creo il menu
        //if (node.Livello != this.state.LivelloFoglie)
        //    return node.text

        //let textProps = {}
        //let icon = <BankOutlined />
        //if (node.IsDisabled === true) {
        //    textProps = { type: 'secondary' }
        //    icon = this.renderDisabledIcon()
        //}

        //if (node.IsAssociated === false) {
        //    textProps = { type: 'danger' }
        //    icon = this.renderDisconnectedIcon()
        //}

        return (
            <Text>
                <Dropdown overlay={this.renderTreeMenu(node)} trigger={["click"/*, "contextMenu"*/]}>
                    <Space>
                        {node.icon}{node.title}
                        <DownOutlined />
                    </Space>
                </Dropdown>
            </Text>
        )
    }

    render() {
        return (
            <PageHeader title="Categorie" >
                Questa pagina consente di censire le categorie di costo fisso e di costo variabile.<br />
                Per ottenere una visione ottimale dei movimenti ti consigliamo di organizzarli in categorie di livelli diversi.<br />
                Puoi creare fino a 3 nuove sottocategorie come illustrato nell'esempio, cliccando sul nome della categoria e successivamente premendo "Aggiungi".
                <br />
                <br />
                <Row gutter={[30, 40]}>
                    <Col md={24} lg={11}>
                        <h3>Categorie disponibili</h3>
                        {this.state.Categorie && <Tree defaultExpandAll showLine={{ showLeafIcon: false }} treeData={this.state.Categorie}
                            titleRender={(node: DataNode) => this.renderTreeTitle(node as CatDataNode)}
                        />}

                        {/*this.state.Categorie && <SearchTree source={this.state.Categorie}
                            titleRender={(node: DataNode) => this.renderTreeTitle(node as CatDataNode)}
                        />*/}

                    </Col>
                    <Col xs={0} xl={1}>
                        <Divider type="vertical" style={{ height: '100%' }} />
                    </Col>
                    <Col md={24} lg={12}>
                        <b><p>Nota</p></b>
                        Si ricorda che la definizione di costo fisso o variabile è legata alla periodicità, non all'importo.<br />
                        <u>Variabile:</u><br />
                        Legato in maniera <strong>direttamente proporzionale</strong> all'andamento di incassato/fatturato.<br />
                        Es: se acquisisco la commessa lo sostengo, altrimenti non lo sostengo<br /><br />
                        Esempio tipico provvigioni per i venditori<br /><br />
                        <u>Fisso:</u><br />
                        Costo che devi sostenere <strong>indipendentemente</strong> dal fatto che l'azienda stia producendo o meno.<br />
                        Es:<br />
                        <ul>
                            <li>costo personale dipendente</li>
                            <li>Affitto</li>
                        </ul><br /><br />
                        {/*<EsempioCategorie />*/}
                    </Col>
                </Row>

                {this.state.ModalVisible ?
                    <ModalCategoria
                        id={this.state.SelectedNode?.key as string}
                        visible={this.state.ModalVisible}
                        closeModal={() => this.toggleModal(false)}
                        do={() => this.loadPage()}
                        op={this.state.OperationModal}
                    /> : <></>
                }
            </PageHeader>
        )
    }
}
interface ISearchTree { source: DataNode[], titleRender?: (node: DataNode) => React.ReactNode; }

class SearchTree extends React.Component<ISearchTree> {
    state = {
        searchValue: '',
    };

    onChange = e => {
        const { value } = e.target;
        this.setState({
            searchValue: value,
        });
    };

    render() {
        const { searchValue } = this.state;
        const loop = (data: DataNode[]) =>
            data.map(item => {
                const index = (item.title as string).indexOf(searchValue);
                const beforeStr = (item.title as string).substr(0, index);
                const afterStr = (item.title as string).substr(index + searchValue.length);
                const title =
                    index > -1 ? (
                        <span>
                            {beforeStr}
                            <span className="site-tree-search-value">{searchValue}</span>
                            {afterStr}
                        </span>
                    ) : (
                        <span>{item.title}</span>
                    );
                if (item.children) {
                    return { title, key: item.key, children: loop(item.children) };
                }

                return {
                    title,
                    key: item.key,
                };
            });
        return (
            <div>
                <Search style={{ marginBottom: 8 }} placeholder="Search" onChange={this.onChange} />
                <Tree
                    defaultExpandAll
                    titleRender={this.props.titleRender}
                    showLine={{ showLeafIcon: false }}
                    treeData={loop(this.props.source)}
                />
            </div>
        );
    }
}